export abstract class Helper {
  private static reformatDateString(s: string) {
    const b = s.split(/\D/);
    return b.reverse().join('-');
  }

  public static getTimeStampFromDate(date: string) {
    let subStringdate = date.substring(0, 10);
    let time = date.substring(11).replace(/\s/g, '');
    let tmpDate = this.reformatDateString(subStringdate);
    const validDate = tmpDate + ' ' + time;
    const newDate = new Date(validDate).getTime() / 1000;
    const gmt = newDate + 2 * 3600;
    return gmt;
  }

  public static createDownLoadFile(blob: Blob, fileTyp: string, name: string): void {
    const a = window.document.createElement('a');
    a.href = window.URL.createObjectURL(blob);
    a.download = name + fileTyp;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}
